import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { AdvertisementLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { useTranslation } from "react-i18next";

const KMC_Advertisement_make_Online_Payment = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img
            src="assets/img/Banner/portal-banner5.jpg"
            className="img-fluid"
            alt="alt"
          />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> KMC Advertisement </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {AdvertisementLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="inner-title2">
                <h3 className="fontSizeClass"> Make Online Payment </h3>
              </div>
              <div className="about-head1">
                <div className="dig-login1 dig-login2">
                  <form>
                    <div className="log-form inner-log-form">
                      <h3 className="fontSizeClass">
                        List of Unpaid Advertisement Fee
                      </h3>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Agent Code *:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. X9259"
                            aria-label
                          />
                        </div>
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Unit Code *:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. 05111520120019"
                            aria-label
                          />
                        </div>
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Contact Number*:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="+91 1234567890"
                            aria-label
                          />
                        </div>
                        <div className="col-lg-6 col-md-12 form-group pt-2">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label"
                          >
                            Email:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder
                            aria-label
                          />
                        </div>
                        <div className="col-lg-12 col-md-12 form-group pt-2">
                          <div className="form-group continu align-items-center">
                            <label
                              htmlFor="exampleFormControlInput1"
                              className="form-label"
                            >
                              &nbsp;
                            </label>
                            <button className="btn btn-primary" type="button">
                              Search
                            </button>
                            <button className="btn btn-primary" type="button">
                              Pay
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_Advertisement_make_Online_Payment;
